import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const quotes = ['¿Ya me tomé la pastilla de la mañana?', '¿A qué hora era la cita… era hoy o mañana?', '¿Dónde anoté el cambio de dosis?', 'Se me olvidó pedir el refill y ahora me quedé sin medicamento…'];
export function ProblemSection() {
  return <section className="bg-white py-24 px-6 md:px-12 lg:px-24" data-id="element-78">
      <div className="max-w-5xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-80">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-81">
            ¿Te suena familiar?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-82">
          {quotes.map((quote, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream/50 p-8 rounded-2xl border border-gold/20 shadow-warm relative" data-id="element-83">
              <QuoteIcon className="absolute top-6 left-6 w-8 h-8 text-gold/30 rotate-180" data-id="element-84" />
              <p className="text-xl md:text-2xl text-navy font-medium italic relative z-10 pl-10" data-id="element-85">
                "{quote}"
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-3xl mx-auto text-center bg-navy text-white p-8 md:p-10 rounded-3xl shadow-xl" data-id="element-86">
          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-87">
            La verdad es simple:{' '}
            <strong className="text-gold font-bold" data-id="element-88">
              no es falta de responsabilidad.
            </strong>{' '}
            Es que la salud tiene muchos detalles y, cuando no están
            organizados, se convierten en estrés.
          </p>
        </motion.div>
      </div>
    </section>;
}